import { render, staticRenderFns } from "./Record_detail.vue?vue&type=template&id=0e76aa1e"
import script from "./Record_detail.vue?vue&type=script&lang=js"
export * from "./Record_detail.vue?vue&type=script&lang=js"
import style0 from "./Record_detail.vue?vue&type=style&index=0&id=0e76aa1e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports